<template>
  <div>
    <span v-if="loading">Loading ...</span>
    <span v-else-if="!loading && !users.length">
      Keine QMS Verantwortliche dieser Apotheke zugeteilt.<br>
      Bitte zuerst QMS Verantwortliche zuteilen.
    </span>
    <table v-else class="table is-striped is-fullwidth mt-4">
      <tbody>
        <AuditorList
          :row="row"
          :users="users"
          :isAuditorEditable="isAuditorEditable"
          @updated="$emit('updated')"
          @close="$emit('close')"
        />
      </tbody>
    </table>
  </div>
</template>

<script>

// import ApiService from '@/services/api.service'
import UserService from '@/services/user.service'

import AuditorList from './AuditorList.vue'

export default {
  name: 'ChangeAuditor',
  props: {
    row: {
      required: true,
      type: Object
    },
    isAuditorEditable: {
      required: true,
      type: Boolean
    }
  },
  components: {
    AuditorList
  },
  data () {
    return {
      loading: true,
      users: []
    }
  },
  mounted () {
    this.getUsers()
  },
  methods: {
    async getUsers () {
      this.loading = true
      try {
        const response = await UserService.getQmsResponsibleUser(this.row.store.id)
        this.users = response
      } catch (error) {
        console.log(error)
      }
      this.loading = false
    }
  }
}
</script>
